import type { JSX } from 'react';
import { TextArea } from '../../../_components/TextField.js';
import type { Attachment, CaptureBusyState, FeedbackInline, FeedbackPalette, WidgetStep } from '../types.js';
import { AttachmentBar } from './AttachmentBar.js';

interface CommentStepProps {
  palette: FeedbackPalette;
  step: WidgetStep;
  comment: string;
  onCommentChange: (value: string) => void;
  attachments: Attachment[];
  onAddAttachment: (attachment: Attachment) => void;
  onRemoveAttachment: (index: number) => void;
  onRequestScreenshot: () => Promise<void>;
  onRequestRecording: () => Promise<void>;
  busy: CaptureBusyState;
  inline: FeedbackInline | null;
}

export function CommentStep({
  palette,
  step,
  comment,
  onCommentChange,
  attachments,
  onAddAttachment,
  onRemoveAttachment,
  onRequestScreenshot,
  onRequestRecording,
  busy,
  inline,
}: CommentStepProps): JSX.Element {
  // Attachments default ON. Inline-config opt-out lives at the build-steps
  // level (`inline.attachments !== false`); the step flag is the final say.
  const allowAttachments =
    step.allowAttachments !== false && inline?.attachments !== false;
  const placeholder = step.placeholder ?? inline?.labels?.placeholder ?? 'Tell us more…';

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <TextArea palette={palette} value={comment} onChange={onCommentChange} placeholder={placeholder} rows={5} />
      {allowAttachments && (
        <AttachmentBar
          palette={palette}
          attachments={attachments}
          onAdd={onAddAttachment}
          onRemove={onRemoveAttachment}
          onRequestScreenshot={onRequestScreenshot}
          onRequestRecording={onRequestRecording}
          busy={busy}
        />
      )}
    </div>
  );
}
